import { render, staticRenderFns } from "./MethodListItem.vue?vue&type=template&id=4972b608&"
import script from "./MethodListItem.vue?vue&type=script&lang=js&"
export * from "./MethodListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports